import { SITE_VARIABLES } from '../../../../common/styles/variables';
import { flexRowCenterCenter } from '../../../../common/styles/flex';

interface StylesObject {
  keepWatchingButtonWrapperStyle: { [key: string]: any };
  keepWatchingButtonStyle: { [key: string]: any };
  keepWatchingTextStyle: { [key: string]: any };
}

const titleFontFamily = SITE_VARIABLES.TEXT_FONT_FAMILY.LATO;

const keepWatchingButtonWrapper = {
  opacity: '0.9',
  display: 'flex',
  justifyContent: 'center',
  hide: {
    display: 'none',
  },
};

const keepWatchingButton = {
  ...flexRowCenterCenter,
  cursor: 'pointer',
  width: '149px',
  height: '24px',
  marginTop: '2px',
  borderRadius: SITE_VARIABLES.BORDER_RADIUS.TINY,
  boxShadow: '2px 2px 6px 0 rgba(0, 0, 0, 0.46), 0 2px 4px 0 rgba(0, 0, 0, 0.5)',
  backgroundImage: 'linear-gradient(84deg, #4f7dff 4%, #692ed1 158%, #692ed1 158%)',
  smallSize: {
    width: '91px',
    marginTop: '3px',
  },
};

const keepWatchingText = {
  fontFamily: titleFontFamily,
  fontWeight: '400',
  fontSize: '11px',
  lineHeight: '14px',
  color: SITE_VARIABLES.COLORS.WHITE,
};

export const getKeepWatchingButtonStyleObject = (showKeepWatching: boolean, smallSkippableContent: boolean): StylesObject => ({
  keepWatchingButtonWrapperStyle: [
    keepWatchingButtonWrapper,
    !showKeepWatching && keepWatchingButtonWrapper.hide,
  ],
  keepWatchingButtonStyle: [
    keepWatchingButton,
    smallSkippableContent && keepWatchingButton.smallSize,
  ],
  keepWatchingTextStyle: {
    ...keepWatchingText,
  },
});
